// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'exchange-cases';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='m3.27 3.594.97-1.938A1.415 1.415 0 0 1 5.646.719h.937a1.416 1.416 0 0 1 1.407.937l.969 1.938M.719 6.469H11.26m-5.27 0v1.489m6.398 7.375h9.244s.65 0 .65.65v5.65s0 .648-.65.648h-9.244s-.648 0-.648-.649v-5.65s0-.649.648-.649m1.904 0 .969-1.937a1.415 1.415 0 0 1 1.405-.938h.938a1.416 1.416 0 0 1 1.406.938l.97 1.937m-8.24 2.875h10.54m-5.27 0v1.49M16.531 4.38h.24a4.073 4.073 0 0 1 4.073 4.073M6.23 20.672l1.916-1.916-1.917-1.917' />
    <path d='M1.368 3.594h9.244s.648 0 .648.649v5.65s0 .649-.648.649H1.368s-.65 0-.65-.65v-5.65s0-.648.65-.648m15.402-1.13L14.855 4.38l1.917 1.916M6.469 18.756h-.24a4.073 4.073 0 0 1-4.073-4.073' />
  </g>
);

export const viewBox = '-0.5 -0.5 24 24';
